import * as e from "react";
import r from "../lib/IconBase.es.js";
import t from "../defs/Peace.es.js";
const o = e.forwardRef((a, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...a, weights: t }));
o.displayName = "PeaceIcon";
const n = o;
export {
  n as Peace,
  o as PeaceIcon
};
